module.exports = __webpack_public_path__ + "img/Speaker=Daniel Huang.976042df.png";